import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import hunnyLogoText from 'assets/images/hunny-logo-text.png';
import hunnyLogo from 'assets/images/hunny-logo.png';

const Logo: React.FC<{ isShortMode?: boolean }> = ({ isShortMode }) => {
	return (
		<StyledWrapper>
			<StyledLogo to="/">
				{isShortMode ? (
					<StyledImg src={hunnyLogoText} isShortMode={isShortMode} />
				) : (
					<StyledImg src={hunnyLogoText} isShortMode={isShortMode} />
				)}
			</StyledLogo>
		</StyledWrapper>
	);
};

const StyledImg = styled.img<{ isShortMode: boolean }>`
	transition: 0.2s;
	height: ${(prop) => (prop.isShortMode ? '27px' : '40.5px')};
`;
const StyledWrapper = styled.div``;

const StyledLogo = styled(Link)`
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;

	transition: 0.3s;

	&:hover {
		transform: scale(1.1, 1.1);
	}
`;

export default Logo;
